import PropTypes from 'prop-types'
import styled from 'styled-components/macro'

const NotificationWrapper = styled.div`
  width: 100%;
`

function Notification({ children }) {
  return <NotificationWrapper>{children}</NotificationWrapper>
}

Notification.propTypes = {
  children: PropTypes.node.isRequired,
}

export { Notification }
